import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GooglePayProcess = () => {
  const searchParams = useLocation().search;
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');

  useEffect(() => {
    if (paramPayUrl) {
      window.location.replace(`${paramPayUrl}&orderType=order`);
    }
  }, []);

  return <>In Process...</>;
};

export default GooglePayProcess;
